module.exports = __webpack_public_path__ + "img/bicester-collection_0.964022fb.jpg";